module.exports = __webpack_public_path__ + "img/thompsonp.77bf0451.jpg";